import { createApi } from '@reduxjs/toolkit/query/react';
import publicLoansApiBaseQuery from '@app/api/baseQuery/publicLoansApiBaseQuery';
export const publicBaseApi = createApi({
    reducerPath: 'publicApi',
    baseQuery: publicLoansApiBaseQuery,
    endpoints: () => ({}),
});
